.root {
  display: inline-block;
  line-height: 1; // Keep the progress centered
}

/* Styles applied to the root element if `variant="static"`. */
// static: {
//   transition: theme.transitions.create('transform'),
// },
/* Styles applied to the root element if `variant="indeterminate"`. */
.indeterminate {
  animation: mui-progress-circular-rotate 1.4s linear infinite;
}

/* Styles applied to the root element if `color="primary"`. */
.colorPrimary {
  color: white;
}

/* Styles applied to the root element if `color="secondary"`. */
.colorSecondary {
  color: black;
}

/* Styles applied to the `svg` element. */
.svg {
}

/* Styles applied to the `circle` svg path. */
.circle {
  stroke: currentColor
  // Use butt to follow the specification, by chance, it's already the default CSS value.
  // strokeLinecap: 'butt',
}

/* Styles applied to the `circle` svg path if `variant="static"`. */
// circleStatic: {
//   transition: theme.transitions.create('stroke-dashoffset'),
// },
/* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
.circleIndeterminate {
  animation: mui-progress-circular-dash 1.4s ease-in-out infinite;
  // Some default value that looks fine waiting for the animation to kicks in.
  stroke-dasharray: 80px, 200px;
  stroke-dashoffset: 0px; // Add the unit to fix a Edge 16 and below bug.
}

@keyframes mui-progress-circular-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes mui-progress-circular-dash {
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -120px;
  }
}

